import React, { useState } from 'react';

import { useSound } from '../App';
import { useAppContext } from '../context/AppContext'; // 导入 useAppContext Hook

import { t } from '../i18n/i18n'; // 根据实际文件路径调整

import { ReliableFetch } from "../utils/ReliableFetch.ts";  // ✅ 别名导入（推荐）

const Login = ({ onLogin }) => {
    //========================================================================
    const { 
            ServiceURLPrefix, setSelectedServer,
            setServerName,
            username, setUsername,
            setMessage,
            blockPage, unblockPage,
        } = useAppContext(); // 获取当前的服务器地址

    const handleServerChange = (e) => {
        setSelectedServer(e.target.value);
        setServerName(e.target.options[e.target.selectedIndex].text);
        // console.log("Selected Value:", selectedValue);
        // console.log("Selected Text:", selectedText);
    };
    
    //========================================================================
    const [playSound] = useSound('/goldcoin.mp3');
    //========================================================================
    const [password, setPassword] = useState('');
    //========================================================================
    const handleSubmit = async (e) => {
        e.preventDefault();
        playSound();
        blockPage();
        try {
            const response = await ReliableFetch(`${ServiceURLPrefix}/auth/login`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: `username=${username}&password=${password}`,
            });
            const data = await response.json();
            if (response.ok) {
                onLogin(data.message);
                console.info(`[handleSubmit]: ${data.message}`);
                setMessage(`[INFO]handleSubmit: ${data.message}`);
            } else {
                unblockPage();
                throw new Error(data.detail || 'Why login failed');
            }
        } catch (error) {
            console.error(`[FATAL]handleSubmit: ${error}`);
            setMessage(`[FATAL]handleSubmit: ${error}`);
        }
        unblockPage();
    };
    //========================================================================
    return (
        <div>
            <h2>{t("Login")}</h2>
            <form onSubmit={handleSubmit}>

                <div>{/*FIXME：选择服务器是调试阶段的需要，后面可以把选择服务URL和删除cookie（HttpOnly的前端没法删其实）强制必须登录注释掉，恢复useEffect的/auth/status检测。*/}
                    <label htmlFor="serverSelect">{t("Select Server")}:</label>
                    <select id="serverSelect" value={ServiceURLPrefix} onChange={(e) => handleServerChange(e)}>
                        <option value="https://hqtapi.c2.world:8000">hqtapi.c2.world</option>
                        <option value="https://127.0.0.1:8000">127.0.0.1</option>
                        <option value="https://localhost:8000">Localhost</option>
                        <option value="https://192.168.71.138:8000">192.168.71.138</option>
                        <option value="https://didactic-disco-5ggqx6gwgvvjc47pg-8000.app.github.dev">Github Codespace disco</option>
                        <option value="https://super-succotash-pjw65rpqq7rgc6jj9-8000.app.github.dev">Github Codespace super</option>
                        <option value="https://didactic-space-trout-vqvv4765gqr36x79-8000.app.github.dev">Github Codespace space</option>
                        <option value="https://hqtapi-392937001667.us-central1.run.app">Google Cloud Run</option>
                    </select>
                </div>
                
                <input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
                <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />

                <button type="submit">{t("Login")}</button>
            </form>
        </div>
    );
};
//============================================================================
export default Login;
